import * as React from "react";

import { Checkbox, Classes, Colors } from "@blueprintjs/core";
import { IModerationOptionInput } from "~/graphql/mutations/optionModeration/moderateOptions";
import { IOption } from "~/graphql/queries/optionModeration/optionsPendingImageModeration";
import styled from "~/styled";
import getOptionImage from "~/util/getOptionImage";

interface IProps {
  option: IOption;
  input: IModerationOptionInput;
  setInput: (optionId: string, input: IModerationOptionInput) => void;
}

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
`;

const Hover = styled.div`
  display: none;
  background: #000e;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 36px 18px;
`;

const Wrapper = styled.div`
  border: 1px solid #0003;
  border-radius: 3px;
  position: relative;
  /* width: 300px; */

  &[data-changed] {
    border: 4px solid ${Colors.GREEN3};
  }

  &:hover ${Hover} {
    display: block;
  }
`;

export default class ProductOption extends React.Component<IProps> {
  public render() {
    const { option, input } = this.props;
    const image = getOptionImage(option);
    const changed =
      input.containsLogo ||
      input.containsText ||
      input.hasBackground ||
      input.imageBroken ||
      input.logoCoversProduct;

    if (!image) {
      return null;
    }

    return (
      <Wrapper data-changed={changed || null}>
        {option.product.sourceName}
        <Image src={image.sourceUrl} onError={this.handleBrokenImage} />

        <Hover className={Classes.DARK}>{this.renderCheckboxes()}</Hover>
      </Wrapper>
    );
  }

  private renderCheckboxes() {
    const { input, setInput, option } = this.props;

    const checkboxes = [
      {
        key: "containsLogo",
        label: "Contains logo"
      },
      {
        key: "containsText",
        label: "Contains text"
      },
      {
        key: "logoCoversProduct",
        label: "Logo/text covers product"
      },
      {
        key: "hasBackground",
        label: "Has non-white background"
      },
      {
        key: "imageBroken",
        label: "Image broken"
      }
    ];

    const handleChange = (key: string) => (
      event: React.FormEvent<HTMLInputElement>
    ) => {
      setInput(option.id, {
        [key]: event.currentTarget.checked
      });
    };

    return (
      <>
        {checkboxes.map(checkbox => (
          <Checkbox
            key={checkbox.key}
            checked={input[checkbox.key] || false}
            onChange={handleChange(checkbox.key)}
          >
            {checkbox.label}
          </Checkbox>
        ))}
      </>
    );
  }

  private handleBrokenImage = () => {
    this.props.setInput(this.props.option.id, {
      imageBroken: true
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/ProductOptionModeration/ProductOption.tsx